var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBRememberDeviceCheckAIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 10,
    fill: "#FF592E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.2L8.5 15.7C8.40848 15.6074 8.29948 15.5338 8.17932 15.4836C8.05916 15.4334 7.93023 15.4076 7.8 15.4076C7.66978 15.4076 7.54085 15.4334 7.42069 15.4836C7.30053 15.5338 7.19153 15.6074 7.1 15.7C7.00736 15.7915 6.93381 15.9005 6.88361 16.0207C6.83341 16.1409 6.80756 16.2698 6.80756 16.4C6.80756 16.5302 6.83341 16.6592 6.88361 16.7793C6.93381 16.8995 7.00736 17.0085 7.1 17.1L11.29 21.29C11.68 21.68 12.31 21.68 12.7 21.29L23.3 10.7C23.3926 10.6085 23.4662 10.4995 23.5164 10.3793C23.5666 10.2592 23.5924 10.1302 23.5924 10C23.5924 9.86978 23.5666 9.74085 23.5164 9.62069C23.4662 9.50053 23.3926 9.39153 23.3 9.30001C23.2085 9.20737 23.0995 9.13382 22.9793 9.08362C22.8592 9.03342 22.7302 9.00757 22.6 9.00757C22.4698 9.00757 22.3408 9.03342 22.2207 9.08362C22.1005 9.13382 21.9915 9.20737 21.9 9.30001L12 19.2Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBRememberDeviceCheckAIcon);
export default __webpack_public_path__ + "static/media/b_remember_device_check_a_icon.9f5118154f68f06c0e577df96feeb06b.svg";
export { ForwardRef as ReactComponent };